// Package Imports
import { Modal } from 'antd';

const CustomModal = ({
  openModal,
  hideModal,
  okText,
  cancelText,
  content,
  onclose
}: any) => {

  return (
    <Modal
      open={openModal}
      onOk={() => hideModal(okText)}
      onCancel={() => hideModal(cancelText)}
      okText={okText}
      cancelText={cancelText}
      
      footer={null}
      style={{ width: "50%" }}
      width={600}
    >
      <div className="">
        {content}
      </div>
    </Modal>
  );
};
export default CustomModal;

